module.exports = __webpack_public_path__ + "img/houzuanmoban.prt.3ce08ffd.jpg";